import React from 'react';
import { Button, Icon, Link } from '@chakra-ui/react';
import { FiExternalLink } from 'react-icons/fi';
import { buildAriveDeepLink } from '../../constants/ariveConstants';

export default function AriveDeepLink({ entityType, ariveId, storedDeepLink, size = 'sm', variant = 'outline' }) {
  const url = buildAriveDeepLink(entityType, ariveId, storedDeepLink);
  if (!url) return null;

  return (
    <Button
      as={Link}
      href={url}
      isExternal
      size={size}
      variant={variant}
      colorScheme="blue"
      leftIcon={<Icon as={FiExternalLink} />}
      _hover={{ textDecoration: 'none' }}
    >
      Open in Arive
    </Button>
  );
}
